export default __webpack_public_path__ + "static/media/favicon.61a0e877.ico";